<template>
  <div v-if="$whitelabel.showHeader">
    <!-- ADAC NAV -->
    <nav v-if="$whitelabel.short.toLowerCase() === 'adac'" class="navbar u-flex-wrap u-w100vw" role="navigation" aria-label="main navigation" v-bind:class="{'is-fixed-top': $whitelabel.fixedNavbar}">
      <!-- FIRST ROW: in cooperation with, brand logo -->
      <div class="navbar--firstrow is-hidden-touch">
        <div class="container">
          <div class="navbar-menu">
            <div class="navbar-start">
              <router-link class="navbar-item" to="/">
                <img importance="high" class="navbar-brand__logo" :src="$whitelabel.logoHeader" :alt="$whitelabel.storeName" v-if="$whitelabel.showHeaderLogo" @click="resetSearch" />
                <span v-if="!$whitelabel.showHeaderLogo" @click="resetSearch">Suche</span>
              </router-link>
            </div>

            <div class="navbar-end">
              <div v-if="$whitelabel.supportPhone" class="navbar-item has-text-weight-bold">
                <a :href="`tel:${$whitelabel.supportMail}`"><b-icon icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>&nbsp;&nbsp;{{ $whitelabel.supportPhone }}</a>
              </div>
              <div v-if="$whitelabel.supportMail" class="navbar-item has-text-weight-bold">
                <a :href="`mailto:${$whitelabel.supportMail}`"><b-icon icon="envelope" size="is-small"></b-icon>&nbsp;&nbsp;{{ $whitelabel.supportMail }}</a>
              </div>
              <!-- <div class="navbar-item has-text-weight-bold">
                In Kooperation mit
              </div>
              <div class="navbar-item">
                <img importance="high" class="logo-coop" :src="'https://assets.urlaubsgutschein.kaufen/whitelabel/we-are.travel.svg'" alt="we-are.travel" fetchpriority="high" />
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- SECOND ROW: search, navigation items, cart -->
      <div class="container navbar--secondrow">
        <div class="navbar-brand ">
          <router-link class="navbar-item is-hidden-desktop" to="/" aria-label="Startseite">
            <div class="is-size-7">
              <img class="navbar-brand__logo" :src="$whitelabel.logoHeader" :alt="$whitelabel.storeName" v-if="$whitelabel.showHeaderLogo" @click="resetSearch" />
              <!-- <p class="navbar-brand__subtext">Südbayern e.V.</p> -->
            </div>
          </router-link>

          <div class="navbar-item has-text-weight-semibold is-hidden-touch ml-2">
            <!-- {{ $whitelabel.company }} -->
          </div>

          <div class="navbar-item is-hidden-desktop">
            <a class="has-text-black" @click="isComponentModalActive = true">
              <b-icon icon="search" size="is-small"></b-icon>
            </a>
          </div>

          <div class="navbar-item is-hidden-desktop">
            <router-link
              :to="{
                name: 'account',
              }"
            >
              <b-icon v-if="!hasUser" icon="user" size="is-small"></b-icon>
              <b-icon v-if="hasUser" icon="user-cog" size="is-small"></b-icon>
              <!-- <b-icon icon="user" size="is-small"></b-icon>
              <small v-if="hasUser" class="is-hidden-touch">
                <strong>({{ userName }})</strong>
              </small> -->
            </router-link>
          </div>

          <div class="navbar-item is-hidden-desktop">
            <a class="has-text-black" @click="handleToggleDrawer">
              <b-icon icon="shopping-cart" size="is-small"></b-icon>&nbsp;
              <small class="cart-count has-background-danger has-text-white has-text-weight-bold is-size-7" v-if="itemCount > 0"> {{ itemCount }} </small>
            </a>
          </div>
          <div class="navbar-item is-hidden-desktop">
            <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="mainNavBar" @click="toggleMobileNav" v-bind:class="{'is-active': showMobileNav}">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>
          <!-- <div class="text-coop  is-hidden-desktop">in Kooperation mit we-are.travel</div> -->
        </div>

        <div id="mainNavBar" class="navbar-menu" v-bind:class="{'is-active': showMobileNav}">
          <div class="navbar-end">
            <!-- <router-link class="navbar-item has-text-black is-hidden-touch" to="/" aria-label="Go back to Homepage"> <b-icon icon="home" size="is-small"></b-icon>&nbsp; Startseite </router-link> -->
            <a class="navbar-item has-text-black is-hidden-touch" @click="resetSearch" aria-label="Startseite"> <b-icon icon="home" size="is-small"></b-icon>&nbsp; Startseite </a>

            <a class="navbar-item is-hidden-touch has-text-black" @click="isComponentModalActive = true"> <b-icon icon="search" size="is-small"></b-icon>&nbsp; Urlaub finden </a>

            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link" @click="toggleSubNavItem('countries')">{{ $t('general.travel-destinations') }}</a>

              <div class="navbar-dropdown" data-subnav="countries">
                <router-link
                  v-for="item in menu.countries"
                  :key="item.key"
                  :to="{
                    name: 'search-by-country',
                    params: {
                      iso: item.key,
                      country: $options.filters.removeSpecialChars(item.value),
                    },
                  }"
                  class="navbar-item"
                  ><span class="is-block" @click="toggleMobileNav()">{{ item.value }}</span></router-link
                >
              </div>
            </div>

            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link" @click="toggleSubNavItem('themes')">Themen</a>

              <div class="navbar-dropdown" data-subnav="themes">
                <router-link
                  v-for="item in menu.themes"
                  :key="item.key"
                  :to="{
                    name: 'search-by-theme',
                    params: {
                      id: item.key,
                      name: $options.filters.removeSpecialChars(item.value),
                    },
                  }"
                  class="navbar-item"
                  ><span class="is-block" @click="toggleMobileNav()">{{ item.value }}</span></router-link
                >
              </div>
            </div>

            <!-- <div class="navbar-item" v-if="$whitelabel.isStandalone">
              <router-link
                :to="{
                  name: 'account',
                }"
              >
                <b-icon icon="user" size="is-small"></b-icon>
                <small v-if="hasUser">
                  <strong>({{ userName }})</strong>
                </small>
              </router-link>
            </div> -->
            <div class="navbar-item is-hidden-touch">
              <router-link
                :to="{
                  name: 'userorders',
                }"
              >
                <b-icon v-if="!hasUser" icon="user" size="is-small"></b-icon>
                <b-icon v-if="hasUser" icon="user-cog" size="is-small"></b-icon>
                <!-- <b-icon icon="user" size="is-small"></b-icon>&nbsp;
                <small v-if="hasUser">
                  <strong>({{ userName }})</strong>
                </small> -->
              </router-link>
            </div>

            <a class="has-text-black navbar-item is-hidden-touch" @click="handleToggleDrawer">
              <b-icon icon="shopping-cart" size="is-small"></b-icon>&nbsp;
              <small class="cart-count has-background-danger has-text-white has-text-weight-bold is-size-7" v-if="itemCount > 0"> {{ itemCount }} </small>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- SEARCH MODAL -->
    <b-modal :active.sync="isComponentModalActive" full-screen custom-class="search-modal">
      <MainSearch @search-completed="closeSearchModal" />
    </b-modal>
  </div>
</template>

<script>
import MainSearch from '@/components/MainSearch'
import {mapGetters} from 'vuex'

export default {
  name: 'AdacNavigation',
  components: {
    MainSearch,
  },
  props: {},
  data: function() {
    return {
      showMobileNav: false,
      isComponentModalActive: false,
    }
  },
  computed: {
    ...mapGetters({
      itemCount: 'itemCount',
      menu: 'menu',
      hasUser: 'hasUser',
      userName: 'userName',
    }),
  },
  methods: {
    toggleMobileNav: function() {
      this.showMobileNav = !this.showMobileNav
    },
    toggleSubNavItem: function(item) {
      if (window.innerWidth < 1024) {
        let el = document.querySelector(`[data-subnav='${item}']`)
        el.classList.toggle('is-hidden')
      }
    },
    closeSearchModal() {
      this.isComponentModalActive = false
    },
    handleToggleDrawer() {
      this.$store.dispatch('showDrawer')
    },
    onResize() {
      let items = document.querySelectorAll('.navbar-dropdown')

      if (window.innerWidth < 1024) {
        items.forEach(item => {
          item.classList.add('is-hidden')
        })
      } else {
        items.forEach(item => {
          item.classList.remove('is-hidden')
        })
      }
    },
    resetSearch() {
      window.location.href = '/'
      //this.$store.dispatch('$_search/resetSearch')
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style lang="scss">
.navbar--firstrow {
  border-bottom: 1px solid #000;
  width: 100%;
  flex-wrap: wrap;
}

.navbar--secondrow {
  min-height: 0 !important; //instead of initial > ie11 support
  padding-top: 0.5rem;
  //padding-bottom: 0.5rem;

  .navbar-brand {
    //min-height: 5rem !important;
    min-height: 0 !important;

    .navbar-item:first-child {
      // to move burger to right
      flex: 1;
    }
  }

  .navbar-brand__subtext {
    margin-top: 0.25rem;
  }

  .navbar-item {
    line-height: 1.2;
  }

  .navbar-burger {
    width: 3rem;
  }

  .is-size-7 {
    font-size: 0.6rem !important;
  }
}

.logo-coop {
  background-color: #fff;
  width: 152px;
  max-height: 50px !important;
  padding: 0.3rem 0.5rem;
}

.text-coop {
  position: absolute;
  top: 0.2rem;
  right: 0.5rem;
  font-size: 0.6rem;
  font-weight: 700;
}

.navbar-menu {
  z-index: 9999;
}

.navbar .navbar-burger {
  height: 4.5rem;
}

.navbar-brand__logo {
  max-height: none !important;
  width: /*50vw*/ 40vw;
  max-width: 250px;
}

.search-modal.is-full-screen {
  > .animation-content {
    //background-color: rgba(#95c11f, 0.9) !important; //overwrite bulma styles
    max-height: 104vh !important; //overwrite bulma styles;
  }

  > .modal-background {
    display: none;
  }
}
</style>
